export default __webpack_public_path__ + "static/media/escoffier_edu_logo.c8b1a487.png";